import { BCMSRecord, DisabledPrompt, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import SettingsPageWrapper from "components/shared/containers/SettingsPageWrapper";
import BaseToggleView from "components/shared/views/BaseToggleView";
import { UIPrimaryButton } from "components/ui/UIButton";
import { Card } from "model";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function HideShowCardsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for HideShowCardsPage
 */

export default function HideShowCardsPage(props) {
  const globalController = useBCMSContext();
    const navigate = useRoute();
    
    const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";

    const showAddCards = globalController.state.branding.options.add_card_chw23  !== "false";

    BCMSRecord.globalControllerFor([ Card ], globalController);

    const cards = Card.initAll().filter((card)=>{

      if(card.type === "debit"){
       return globalController.state.branding.options.include_debit_chw23  !== "false";
      }else{
        return globalController.state.branding.options.include_credit_chw23  !== "false";
      }
    });
    const cardToggles = cards.map((card)=>{
     return <BaseToggleView mainText={card.owner} subText={`${card.type} ${card.maskedNumber}`} icon={<SVGAsset id="OutlineCardIcon" />} checked={true} dataPoint={`Toggle_Card_${card.id}`} key={card.id}/>
    }) 
    // Filter all cards by the card id and then sort by date
 
  return (
    <SettingsPageWrapper className="hide-show-card-page">
      <MainContentContainer header={<MainContentHeader text="Hide/Show Cards" icon="LeftChevronIcon" dataPoint="Hide_Show"/>}>
        <div className="text-container">
          <p>Selected cards can be managed in the app. </p>
          <p className="middle-text">Unselected cards will be hidden. You won't be able to manage a hidden card, and its activity will not appear in your transaction or spending data.</p>
          <p>Select cards to be managed. </p>
        </div>
        <MainContentSection text="Cards">
          <FormContainer>
            <FormRow>
            {cardToggles}
            </FormRow>
           {showAddCards && <FormRow>
              <DisabledPrompt>
                <div className="flex-container flex-horizontal align-center-container add-card-container clickable">
                  <SVGAsset id="OutlineCardIcon" className="set-width left-inline-icon" />
                  <div className="flex-container flex-vertical flex-width">
                    <p className="main-text"><span data-point={`Toggle_Card_Add`}>Add Card</span></p>
                    <p className="sub-text">Add a new card to manage</p>
                  </div>
                  <SVGAsset id="CirclePlusIcon" className="set-width"  data-point={`Toggle_Card_Add_Icon`}/>
                </div>
              </DisabledPrompt>
            </FormRow>
            }
            <FormButtonContainer>
              <DisabledPrompt>
                <UIPrimaryButton text="Save"  dataPoint={`Toggle_Card_Save`}/>
              </DisabledPrompt>
            </FormButtonContainer>
          </FormContainer>
        </MainContentSection>
      </MainContentContainer>
    </SettingsPageWrapper>

  );
}